import { useState } from "preact/hooks";

export function useCoalesced<T>(data: T | null, enable = true): T | null {
    const [value, setValue] = useState(data);
    if (enable && data != value && data) {
        setValue(data);
    }
    return enable ? value : data;
}
